import React, { useEffect } from "react";
import "./VarifyKyc.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { GetStepsDetail } from "../../../features/admin/kycverification/kyc/Slice";
import { useDispatch, useSelector } from "react-redux";

const VarifyKyc = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const stepDetail = useSelector(
    (state) => state?.kycverification?.kyc?.stepdetail,
  );

  const kycStatus = stepDetail?.kyc_identity_verification?.status;

  useEffect(() => {
    dispatch(GetStepsDetail());
  }, [dispatch]);

  return (
    <section className="container px-lg-5 pt-4">
      <div
        className="kyc-card"
        onClick={() => {
          if (kycStatus !== "verified") {
            navigate("/identityVarification");
          }
        }}
      >
        <div className="kyc-left">
          <div className="kyc-avatar">
            <div className="kyc-img-box">
              <img
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0"
                alt="user"
              />
            </div>
            <span className="kyc-check">
              <img src="/images/profile/ok.png" alt="" />
            </span>
          </div>

          <div className="kyc-text">
            <h4>Complete Your KYC</h4>

            {kycStatus === "pending" && (
              <>
                <p>
                  Verify your identity to activate your account and start
                  earning securely.
                </p>
                <p className="kyc-pending">Your KYC is pending for approval</p>
              </>
            )}

            {kycStatus === "verified" && (
              <p className="kyc-verified">Your KYC is verified!</p>
            )}

            {kycStatus === "rejected" && (
              <>
                <p>
                  Verify your identity to activate your account and start
                  earning securely.
                </p>
                <p className="kyc-rejected">
                  Your KYC is rejected. Please verify it again.
                </p>
              </>
            )}

            {!kycStatus && (
              <p>
                Verify your identity to activate your account and start earning
                securely.
              </p>
            )}
          </div>
        </div>

        {(kycStatus === "rejected" || !kycStatus) && (
          <button className="kyc-btn">
            Verify Now
            <FontAwesomeIcon className="arrow" icon={faArrowRight} />
          </button>
        )}
      </div>
    </section>
  );
};

export default VarifyKyc;
